/**
 * User: herbert
 * Date: 14.02.16
 * Time: 18:07
 */


import Reflux from 'reflux';

export default Reflux.createActions({
	/**
	 * set selected color but don't apply it
	 * @param finish selected finish out of config-finish's array
	 */
	select: {},
	/**
	 * aply last selected color
	 */
	apply: {}
});
